import React from 'react';
import LoginC from './Login/Login';

const Login = () => {
  return <LoginC/> ;
};

export default Login;